import { render } from "./App.vue?vue&type=template&id=708cc8ed"
const script = {}

import "./App.vue?vue&type=style&index=0&id=708cc8ed&lang=scss"

import exportComponent from "/home/runner/work/ev-connect-dashboard/ev-connect-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__